import React from "react";
import { useLocale } from "@/context/LocaleContext";
import { LanguageSwitch } from "@/components/LanguageSwitch";

const BRAND_URL = "https://grupptipset.se";

/** Logo top-left + optional pre-login language switch on auth pages. */
export function AuthPageHeader({ showLanguage = true }) {
  const { t } = useLocale();

  return (
    <header className="flex items-center justify-between gap-3 px-4 py-4 shrink-0 w-full">
      <a
        href={BRAND_URL}
        className="font-display text-2xl sm:text-3xl tracking-[0.06em] text-[var(--text)] hover:text-[var(--accent)] transition-colors shrink-0"
        data-testid="brand-title"
      >
        {t("dashboard.brand")}
      </a>
      {showLanguage ? <LanguageSwitch matchedWidth /> : null}
    </header>
  );
}
